import React, { useContext, useEffect, useState } from 'react';
import { ProjectsContext } from '../../../../contexts/ProjectsContext';
import { CapitalizeWords } from '../../../../utils/otherFormat';
import { formatNumberWithCommas } from '../../../../utils';

export const ProjectOfferSlider: React.FC = () => {
    const context = useContext(ProjectsContext);
    const { projectCards } = context;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [prevIndex, setPrevIndex] = useState<number | null>(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setPrevIndex(currentIndex);
            setCurrentIndex((prevIndex) =>
                (prevIndex + 1) % projectCards.length
            );
        }, 5000);
        return () => clearInterval(interval);
    }, [currentIndex, projectCards.length]);

    return (
        <div className="carousel">
            {projectCards.map((projectCard, index) => (
                <div
                    key={index}
                    className={`
                        ${index === currentIndex ? 'active' : ''}
                        ${index === prevIndex ? 'exiting' : ''}
                    `}
                >
                    <h3 className='primaryFont mt-4 text-xl font-normal text-black'>
                        Invierte en <strong>{CapitalizeWords(projectCard.name)}</strong> desde
                    </h3>
                    <span className='numberFont text-5xl font-bold text-black truncate'>
                        {`$${formatNumberWithCommas(projectCard.minInvestmentUnits * projectCard.unitPrice, 0)} COP`}
                    </span>
                </div>
            ))}
        </div>
    );
};
